const LEGEND_PLACEHOLDER_HEIGHT = 32
const RIGHT_LEGEND_MAX_CHARS = 28
const TRANSPARENT = "rgba(0,0,0,0)"

const wrapText = (text, maxChars) => {
    const words = String(text ?? "").split(/\s+/).filter(Boolean)
    if (words.length === 0) return [""]
    const lines = []
    let current = ""
    for (const word of words) {
        if (!current) {
            current = word
        } else if ((current + " " + word).length <= maxChars) {
            current += " " + word
        } else {
            lines.push(current)
            current = word
        }
    }
    if (current) lines.push(current)
    return lines
}

const wrappedRightLegendLabels = (chart) => {
    const items = []
    chart.data.datasets.forEach((ds, datasetIndex) => {
        const lines = wrapText(ds.label, RIGHT_LEGEND_MAX_CHARS)
        const visible = chart.isDatasetVisible(datasetIndex)
        lines.forEach((line, lineIdx) => {
            const isFirst = lineIdx === 0
            items.push({
                text: line,
                fillStyle: isFirst ? ds.backgroundColor : TRANSPARENT,
                strokeStyle: isFirst ? ds.backgroundColor : TRANSPARENT,
                lineWidth: 0,
                pointStyle: "circle",
                hidden: !visible,
                datasetIndex,
            })
        })
    })
    return items
}

export const legendPositionMap = {
    NONE: {legend: {display: false}},
    BOTTOM: {
        legend: {display: true, position: "bottom", align: "start", labels: {usePointStyle: true, pointStyle: "circle"}},
    },
    RIGHT: {
        legend: {
            display: true,
            position: "right",
            align: "end",
            labels: {
                usePointStyle: true,
                pointStyle: "circle",
                generateLabels: wrappedRightLegendLabels,
            },
        },
    },
    PLACEHOLDER_BOTTOM: {
        legend: {display: false},
        layoutPadding: {bottom: LEGEND_PLACEHOLDER_HEIGHT},
    },
}

export const buildStackedBarchartOptions = (bottomLabels, legendEntry) => ({
    layout: {
        padding: legendEntry.layoutPadding ?? {},
    },
    plugins: {
        legend: legendEntry.legend,
        tooltip: {
            bodyAlign: "center",
            bodyFont: {family: 'SI Sans', weight: 'bold', size: 14},
            callbacks: {
                title: () => "",
                label: (data) => [data.dataset.label + ":", (data.raw).toLocaleString("de-DE", {
                    style: "currency", currency: "EUR", minimumFractionDigits: 2,
                })],
            },
        },
    },
    datasets: {
        bar: {
            categoryPercentage: 0.9,
            barPercentage: 0.85,
            maxBarThickness: 64,
            borderRadius: 4,
        },
    },
    maintainAspectRatio: false,
    aspectRatio: 1,
    responsive: true,
    scales: {
        x: {
            border: {display: false},
            position: "top",
            stacked: true,
            grid: {display: false},
            ticks: {display: false},
        },
        y: {
            border: {display: false},
            stacked: true,
            grid: {display: true},
            ticks: {
                display: true,
                callback: (value) => value.toLocaleString("de-DE", {style: "currency", currency: "EUR", minimumFractionDigits: 0}),
            },
        },
        titles: {
            border: {display: false},
            stacked: true,
            position: "bottom",
            grid: {display: false},
            ticks: {
                callback: (_, index) => bottomLabels[index],
                color: "black",
                font: {family: 'Urbanist,Arial,sans-serif', weight: 500, size: 14},
            },
        },
    },
})
